<!-- FUNKTIONIERT NICHT WEGEN DER VERSCHACHTELUNG. GALERIE WIRD DIREKT IN DER ELTERN-KOMPONENTE REALISIERT. -->


<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-container grid-list-sm fluid>
                    <v-layout row wrap>
                        <v-flex
                                v-for="photo in photoArray(contractProductIndex)"
                                :key="photo.data"
                                xs4
                                d-flex
                        >
                            <v-card flat tile class="d-flex">
                                <v-img
                                        :src="photo.data"
                                        :lazy-src="photo.data"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                >
                                </v-img>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "PhotoGallery",
        data: () => {
            return {
            }
        },
        computed: {
            ...mapGetters('work', {
                photoArray: 'getPhotoArray'
            })
        },
        props: {
            contractProductIndex: {
                default: 0
            }
        }
    }
</script>

<style scoped>

</style>
